<svelte:head>
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/css/bootstrap.min.css">
	<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/js/bootstrap.min.js"></script>
	<script src="https://cdn.jsdelivr.net/npm/js-loading-overlay@1.1.0/dist/js-loading-overlay.min.js"></script>
</svelte:head>

<script>
	import { onMount } from "svelte";
	import { IsMobile } from './stores.js'
	import Header from "./Header.svelte";
	import Canvas from "./Canvas.svelte";

	var loading_configs = {
		'overlayBackgroundColor': '#666666',
		'overlayOpacity': 0.6,
		'spinnerIcon': 'ball-circus',
		'spinnerColor': '#000',
		'spinnerSize': '3x',
		'overlayIDName': 'overlay',
		'spinnerIDName': 'spinner',
		'offsetY': 0,
		'offsetX': 0,
		'lockScroll': false,
		'containerID': null,
	};
	let LoadingText = "Loading...";

	let innerWidth = 0;
    let innerHeight = 0;
	let url = '';
	let AlarmCode = '';

	let AlertData = {};
	let MessageLines = [];

	let Sources = {};
	let Responsibilities = {};
	let Log = {};

	let div1Style = 'show';
	let div2Style = 'no-show';

	let Alert_ID = -1;
	let SelectedSource = 0;
	let SelectedResponsibility = 0;
	let EnteredBy = '';
	let Notes = "";
	let Lat = -1;
	let Lng = -1;
	let IP = "";
	let Notify = true;

	let Image_b64 = "";
	let FileName = "";
	let  avatar, fileinput;
	
	let EnableSubmit = '';

	// Formats that browsers and email clients display natively — stored as-is.
	const PASSTHROUGH_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/bmp"];

	// Re-encode any browser-decodable image to JPEG via canvas. Rejects (onerror)
	// for formats the browser can't decode, e.g. camera RAW or TIFF.
	const convertToJpeg = (blob) => new Promise((resolve, reject) => {
		const url = URL.createObjectURL(blob);
		const img = new Image();
		img.onload = () => {
			URL.revokeObjectURL(url);
			const canvas = document.createElement("canvas");
			canvas.width = img.naturalWidth;
			canvas.height = img.naturalHeight;
			canvas.getContext("2d").drawImage(img, 0, 0);
			canvas.toBlob((out) => out ? resolve(out) : reject(new Error("toBlob failed")), "image/jpeg", 0.9);
		};
		img.onerror = () => {
			URL.revokeObjectURL(url);
			reject(new Error("Browser cannot decode this image format"));
		};
		img.src = url;
	});

	const onFileSelected = async (e)=>{
		let image = e.target.files[0];
		if (!image) return;

		// Capture the ORIGINAL filename now — conversion below replaces `image`
		// with a nameless Blob. Sent to the server to build the stored object key.
		FileName = image.name || "";

		try {
			if (PASSTHROUGH_TYPES.includes(image.type)) {
				// Already a web-displayable format — keep as-is.
			} else if (/image\/hei[cf]/i.test(image.type) || /\.hei[cf]$/i.test(image.name)) {
				// HEIC/HEIF (iPhone photos) — decode via libheif and re-encode to JPEG.
				// The ~1.3MB decoder is lazy-loaded only when a HEIC file is actually picked.
				const heic2any = (await import("heic2any")).default;
				image = await heic2any({ blob: image, toType: "image/jpeg", quality: 0.9 });
			} else {
				// Any other format the browser can decode — re-encode to JPEG.
				// Niche/RAW formats (TIFF, .cr2, .nef, ...) fail here and are rejected below.
				image = await convertToJpeg(image);
			}
		} catch (err) {
			console.log("Image conversion failed:", err);
			alert("Sorry, that image type isn't supported. Please use a JPG, PNG, GIF, WebP, BMP, or HEIC image.");
			e.target.value = "";
			FileName = "";
			return;
		}

		let reader = new FileReader();
		reader.readAsDataURL(image);
		reader.onload = e => {
			avatar = e.target.result
			Image_b64 = e.target.result;
		};


	};

	onMount(async function () {
		url = window.location.href;
		AlarmCode = url.split('/').pop();
		console.log(AlarmCode);

		if(innerWidth < 768){
			$IsMobile = true; 
		}	

		GetAlertData();

		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((position) =>{ 
				Lat = position.coords.latitude;
			  	Lng = position.coords.longitude;
			});    		
		}
		GetIP();
	});

	async function GetIP(){
		let response = await fetch('https://api.ipify.org?format=json');
		let data = await response.json();
		IP = data.ip;
	}

	async function GetAlertData(){		
		let Done = false;
		try{
			setTimeout(function(){
				if(Done == false){
					JsLoadingOverlay.show(loading_configs);
				}
			}, 200);
		} catch (error) {
			console.log(error);
		}

		const res = await fetch('/alert_details', {
            method: 'POST',
            contentType: "application/json",
            body: JSON.stringify({
				'AlarmCode': AlarmCode,
            })
        });		
        const json = await res.json();
        if(json['Result'] == "Success"){
			Done = true;
			JsLoadingOverlay.hide();
			console.log(json);
			AlertData = json['Data'][0];
			//console.log(AlertData);
			MessageLines = AlertData['Message'].split("\r\n");
			
			Alert_ID = AlertData['Alert_ID'];
			Sources = json['Sources'];
	 		Responsibilities = json['Responsibilities'];
	 		Log = json['Log'];

			SelectedSource = Sources[0].AlertExceedanceSource_ID;
			SelectedResponsibility = Responsibilities[0].AlertExceedanceResponsibility_ID;

			div2Style = 'show';
			div1Style = 'no-show';
		}else{
			Done = true;
			LoadingText = "No Data Found";
			JsLoadingOverlay.hide();
			console.log(json);
		}
	}

	async function Submit(){
		let i;
		let strSelectedSource = '';
		let strSelectedResponsibility = '';

		for(i in Sources){
			if(Sources[i].AlertExceedanceSource_ID == SelectedSource){
				strSelectedSource = Sources[i].Description;
				break;
			}
		}
		for(i in Responsibilities){
			if(Responsibilities[i].AlertExceedanceResponsibility_ID == SelectedResponsibility){
				strSelectedResponsibility = Responsibilities[i].Description;
				break;
			}
		}
		JsLoadingOverlay.show(loading_configs);

		const res = await fetch('/submit', {
            method: 'POST',
            contentType: "application/json",
            body: JSON.stringify({
				'Alert_ID': Alert_ID,
				'SelectedSource': SelectedSource,
				'SelectedResponsibility': SelectedResponsibility,
				'strSelectedSource': strSelectedSource,
				'strSelectedResponsibility':strSelectedResponsibility,
				'EnteredBy': EnteredBy,
				'Notes': Notes,  
				'Lat': Lat,
				'Lng': Lng,
				'IP': IP, 
				'Image_b64': Image_b64,
				'FileName': FileName,
				'Notify':Notify,
				'AlertData': AlertData,			
            })
        });		
        const json = await res.json();
        if(json['Result'] == "Success"){
			console.log(json);
			JsLoadingOverlay.hide();
			EnableSubmit = 'disabled';
			alert("Thank you for your submission");
		}else{
			JsLoadingOverlay.hide();
			console.log(json);
			alert(json['Message'] || "Error submitting. Please check your data and try again.");
		}
	}

</script>

<style>
	.show{
		display: block;
		height: 100%;
	}
	.no-show{
		display: none;
		height: 0px;

	}

	.data{
		margin: auto;
		width: 50%;
		height: 100%;
		padding: 10px;
		text-align: center;
		/* border: 1px solid #ccc; */
	}

	#app{
		display:flex;
		align-items:center;
		justify-content:center;
		flex-flow:column;		
	}

	.upload{
		display:flex;
		height:50px;
		width:50px;
		cursor:pointer;
		
	}
	.avatar{
		display:flex;
		height:200px;
		width:200px;
	}

	.smtx{
		font-size: 12px;
		font-weight: bold;
		text-align: right;
	}

	.cklb{
		align-items: left;
		text-align: left;
		padding: 0px;
		font-size: 14px;
		font-weight: bold;
		margin-top: 10px; 
	}

	.droptext{
		font-size: 12px;
	}

	img {
		margin: auto;
		display: block;		
	}

	.imgbtn{
		align-items: center;
		text-align: center;
		padding: 0px;
		/* border-width: 5px;
		border-style: solid; */
		width: 50vw;
		margin: auto;
	}

	.submitbtn{
		margin-top: 10px;
		align-items: center;
		text-align: center;
		border-width: 5px;
		border-style: solid;
		width: 80vw;
		margin: auto;
	}

	@media only screen and (max-width: 768px) {
		.data{
			width: 98%;
		} 

		.smtx{
			font-size: 10px;
		}

		.avatar{
			height:100px;
			width:100px;
		}

		.ckbxtxt{
			font-size: 12px;
		}
	}

	@media only screen and (max-width: 360px) {
		.data{
			width: 100%;
		} 

		.smtx{
			font-size: 9px;
		}
	}
</style>

<svelte:window bind:innerWidth bind:innerHeight />

<Header/>

<Canvas>
	<div slot="box1">
		<div class={div1Style}>
			<div class="data">
				<h1>{LoadingText}</h1>
			</div>
		</div>

		<div class={div2Style}>
			<div class="data">
				{#each MessageLines as line, i}
					{#if i == 0}
						<h1>{line}</h1>
					{:else}
						{line}<br>
					{/if}
				{/each}

				<hr>

				<div class="row">
					<label for="exceedance-source" class="lb-20 col-4 smtx">Exceedance Source:</label>
					<select class="form-control form-control-sm col droptext" id="exceedance-source" bind:value={SelectedSource}>
						{#each Object.entries(Sources) as source}
							<option value={parseInt(source[1].AlertExceedanceSource_ID)}>
								{source[1].Description}
							</option>
						{/each}
					</select>
				</div>
				<div class="row">
					<label for="exceedance-responsibility" class="lb-20 col-4 smtx">Caused By:</label>
					<select class="form-control form-control-sm col droptext" id="exceedance-responsibility" bind:value={SelectedResponsibility}>
						{#each Object.entries(Responsibilities) as responsibilitie}
							<option value={parseInt(responsibilitie[1].AlertExceedanceResponsibility_ID)}>
								{responsibilitie[1].Description}
							</option>
						{/each}
					</select>
				</div>
				<div class="row">
					<label for="entry-by" class="lb-20 col-4 smtx">Response By:</label>
					<input type="text"  class="form-control form-control-sm col droptext" id="entry-by" placeholder="Your Name" bind:value={EnteredBy} />						
				</div>
				<div class="row">
					<label for="notes" class="lb-20 col-4 smtx">Notes:</label>
					<textarea  class="form-control form-control-sm col droptext" id="notes" bind:value={Notes}/>						
				</div>
				<div class="row">
					<div class="col-4">&nbsp;</div>
					<div class="col cklb">
						<input class="form-check-input " type="checkbox" value="" id="ckbxNotify" bind:checked={Notify}>
						<label class="form-check-label ckbxtxt" for="ckbxNotify">
						  Notify email/SMS distribution list?
						</label>
					  </div>				
				</div>
				<br>
				<div id="app">	
					<div class="row">
						<div class="col">
							{#if avatar}
							<img class="avatar" src="{avatar}" alt="d" />
							{:else}
							<!-- <img class="avatar" src="https://cdn4.iconfinder.com/data/icons/small-n-flat/24/user-alt-512.png" alt="" />  -->
							<div>&nbsp;</div>
							{/if}
						</div>
						{#if avatar}
							<div class="col imgbtn">
								<img class="upload" src="https://static.thenounproject.com/png/625182-200.png" alt="" on:click={()=>{fileinput.click();}} disabled='{EnableSubmit}'/>
								<div class="chan" on:click={()=>{fileinput.click();}}>Choose Image</div>
								<input style="display:none" type="file" accept="image/*,.heic,.heif" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} >
							</div>
						{:else}
							<div class="imgbtn">
								<img class="upload" src="https://static.thenounproject.com/png/625182-200.png" alt="" on:click={()=>{fileinput.click();}} disabled='{EnableSubmit}'/>
								<div class="chan" on:click={()=>{fileinput.click();}}>Choose Image</div>
								<input style="display:none" type="file" accept="image/*,.heic,.heif" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} >
							</div>
						{/if}
										
					</div>		  	
				</div>
				<div class="row">
					<button class="btn btn-primary submitbtn" on:click={Submit} disabled='{EnableSubmit}'>Submit</button>					
				</div>
				<hr>
			</div>
		</div>
	</div>
</Canvas>
